import { Component, DoCheck, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Utility } from '../../../../shared/utility/utility';
import { EmitterService } from '../../../../services/emitter.service';

@Component({
  selector: 'app-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss']
})
export class DynamicInputComponent implements OnInit {

    @Input() field:any = {};
    @Input() form:FormGroup;
    errorMessage='';
    formValue;
    validationClass = '';
    isSubmitted = false;
    isShowValidation = false;
    @ViewChild('dynamicInputElement') dynamicInputElement:ElementRef;
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }
  
    constructor(private utils:Utility,private emitterService:EmitterService) {

    }
    ngOnInit(): void {
      this.emitterService.emitSubmitFormClick$.subscribe((status)=>{
        this.isSubmitted = true;
        this.isShowValidation = true;
        this.getValidationClass();
      });
    }

    ngDoCheck(): void {
        this.getValidationClass();
    }
    onKeyUp($event){
     let inputValue = $event.target.value ? $event.target.value.toString() : ''; 
     if(inputValue && this.field.name == 'cardNumber'){
      inputValue = inputValue.replaceAll(" ",'');
      let res = [...inputValue].map((d, i) => (i) % 4 == 0 ? ' ' + d : d).join('').trim()
      this.form.controls[this.field.name].setValue(res);
     }
     if(this.field.name == 'cardExpiry'){
      this.cexpiryDateValidation($event);
     }
    }

    cexpiryDateValidation(event){
        var code = event.keyCode;
        var allowedKeys = [8];
        if (allowedKeys.indexOf(code) !== -1) {
          return;
        }
      
        event.target.value = event.target.value.replace(
          /^([1-9]\/|[2-9])$/g, '0$1/' // 3 > 03/
        ).replace(
          /^(0[1-9]|1[0-2])$/g, '$1/' // 11 > 11/
        ).replace(
          /^([0-1])([3-9])$/g, '0$1/$2' // 13 > 01/3
        ).replace(
          /^(0?[1-9]|1[0-2])([0-9]{2})$/g, '0$1/$2' // 141 > 01/41
        ).replace(
          /^([0]+)\/|[0]+$/g, '0' // 0/ > 0 and 00 > 0
        ).replace(
          /[^\d\/]|^[\/]*$/g, '' // To allow only digits and `/`
        ).replace(/\/\//g, '/');
      }
      
      onKeyDown(event){
        if((event.which >= 65 && event.which <= 90)  && this.field.name == 'cardExpiry'){
          event.preventDefault();
        }
        if(event.which == 190 || event.keyCode == 187 || event.which == 48 && !this.form.controls[this.field.name].value && this.field.name == 'cardCvv' && this.form.controls[this.field.name].value){
          event.preventDefault();
        }
        this.getValidationClass();
      }
      shouldShowErrors(fieldName, formName) {
          return this.utils.shouldShowErrors(fieldName, formName);
      }
      getValidationClass(isFocus = false) {
        if(this.isShowValidation || this.isSubmitted){
          let fieldName = this.field.name;
          let formName = this.form;
          if(this.form.controls[fieldName].invalid){
            this.validationClass = '';
          }
         
            if(this.shouldShowErrors(fieldName, formName)){
              this.validationClass =  (this.form.controls[this.field.name].value && !this.isSubmitted) || this.isSubmitted  ? 'field-invalid' : ''; 
              this.showErrorMessage();
            }else if(!this.shouldShowErrors(fieldName, formName)){
              this.validationClass =  this.form.controls[this.field.name].value ? 'field-valid' : ''; 
            }
            this.checkFieldValidation();
        }
      }
      checkFieldValidation(isOnBlur = false){
        if(isOnBlur){
          let value = this.form.controls[this.field.name].value;
          if(value && value.trim()){
            this.form.controls[this.field.name].setValue(value.trim())
          }
        }

        if(this.form.controls[this.field.name].value || this.isSubmitted){
          this.showErrorMessage();
          this.isShowValidation = true;
        }else {
          let getElement:any = document.getElementsByClassName(`error-message-${this.field.name}`)
          if(getElement && getElement[0]){
             getElement[0].style.display='none';
          }
        }
      }

      showErrorMessage(){
        let getElement:any = document.getElementsByClassName(`error-message-${this.field.name}`)
        if(getElement && getElement[0]){
           getElement[0].style.display='block';
        }
      }

}
